import { Component, inject } from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';
import { SVGIconComponent } from '@progress/kendo-angular-icons';
import { KENDO_GRIDLAYOUT, KENDO_STACKLAYOUT } from '@progress/kendo-angular-layout';
import { IconService } from '@unity/services/icon.service';
import { SessionService } from '@unity/services/session.service';

@Component({
  selector: 'unity-panel-context-shared',
  standalone: true,
  imports: [KENDO_GRIDLAYOUT, KENDO_STACKLAYOUT, SVGIconComponent, RouterLinkWithHref],
  templateUrl: './panel-context-shared.component.html',
  styleUrl: './panel-context-shared.component.scss',
})
export class PanelContextSharedComponent {
  private readonly sessionService = inject(SessionService);
  private readonly iconService = inject(IconService);

  protected logoPanelWidth = 'minmax(1fr, auto)';
  protected exitImpersonationText = 'Click here to exit impersonation.';
  protected profileIcon = this.iconService.gearsIcon;

  protected $currentUser = this.sessionService.$user;
  protected $currentAgencyRole = this.sessionService.$currentAgencyRole;
  protected $isImpersonating = this.sessionService.$isImpersonating;

  protected onClick = () => this.sessionService.endImpersonation();
}
